export function phoneValidate(phone: string) {
  if (phone.replaceAll(/[()_ -]/g, '').length === 11) {
    return true
  } else return false
}
